import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { Trans } from "react-i18next";

function RegisterButton({
  canRegister,
  cannotRegisterReason,
  onSubmit,
  willBeWaitingList
}) {
  const registrationButton = (
    <div style={{ display: "inline-block" }}>
      <Button
        disabled={!canRegister}
        onClick={onSubmit}
        primary
        className={!canRegister ? "icon" : ""}
      >
        {canRegister ? (
          willBeWaitingList ? (
            <Trans i18nKey="coursePlan.registration.actions.waitingList" />
          ) : (
            <Trans i18nKey="coursePlan.registration.actions.register" />
          )
        ) : (
          <Icon name="info" />
        )}
      </Button>
    </div>
  );

  return cannotRegisterReason ? (
    <Popup trigger={registrationButton}>
      <Popup.Content>
        <Trans
          i18nKey={`errors.fieldErrors.registration.${cannotRegisterReason}`}
        />
      </Popup.Content>
    </Popup>
  ) : (
    registrationButton
  );
}

RegisterButton.displayName = "coursePlan/register/RegisterButton";

export default React.memo(RegisterButton);
